import { render, staticRenderFns } from "./suZhouPoints.vue?vue&type=template&id=31022fbb"
import script from "./suZhouPoints.vue?vue&type=script&lang=js"
export * from "./suZhouPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports